/**
 * This component wraps React-Router's Redirect by providing name-based routing.
 * (Helps to narrow down the scope of possible format changes to routes.)
 */
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Navigate } from 'react-router';
import routeConfiguration from '../../routeConfiguration';
import { pathByRouteName } from '../../util/routes';

const NamedRedirect = ({
  name,
  search = '',
  state = {},
  params = {},
  push = false,
  locale: propsLocale,
}) => {
  const intl = useIntl();

  // <Navigate> navigates again whenever its `state` prop changes identity. The default `{}` and
  // inline `state={{ from }}` are new objects on every render, and the page keeps re-rendering
  // while the target route's loader is pending, so each render started a new navigation (and a
  // new loader run). Keep the object stable as long as its content is the same.
  const stateKey = JSON.stringify(state);
  const stableState = useMemo(() => JSON.parse(stateKey), [stateKey]);

  const pathname = pathByRouteName(name, routeConfiguration(), params, propsLocale || intl.locale);
  return <Navigate replace={!push} state={stableState} to={{ pathname, search }} />;
};

export default NamedRedirect;
